import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShoppingCartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    fill="none"
    viewBox="0 0 24 17"
    {...props}
  >
    <path
      stroke="#3152E7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M6.294 5.664h11.274c.287 0 .57.044.83.13.261.085.493.21.68.364.186.155.324.337.402.534.08.196.098.402.054.604l-1.248 5.774c-.108.502-.465.96-1.006 1.29s-1.23.513-1.943.512H8.524c-.713 0-1.402-.181-1.942-.512-.541-.33-.898-.788-1.006-1.29L4.328 7.296a1.03 1.03 0 0 1 .053-.604 1.36 1.36 0 0 1 .403-.534 2.1 2.1 0 0 1 .679-.365c.26-.085.544-.129.83-.129"
    />
    <path
      stroke="#3152E7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.95 7.792V4.25c0-.564.313-1.104.873-1.503s1.318-.622 2.11-.622c.79 0 1.549.224 2.108.622.56.399.874.94.874 1.503v3.542"
    />
  </svg>
);
export default SvgShoppingCartIcon;
